import apiRequest from "@app/utils/apiRequest";

export const requestGetExcludeReceiverIds = (data) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-receivers`, {params: data})

export const requestSaveExcludeReceiverIds = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-receivers`, data)

export const requestDeleteExcludeReceiverIds = (data) =>
    apiRequest.delete(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-receivers`, {data: data});
export const requestGetReceivers = (data) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-cdd-job/receivers`, {params: data})

export const requestSaveReceivers = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/search-cdd-job/receivers`, data)

export const requestDeleteReceivers = (data) =>
    apiRequest.delete(`/dvtjcuv/run-dvtjcuv/search-cdd-job/receivers`, {data: data});



export const requestSaveExcludeEmployerIds = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-employers`, data)
export const requestGetExcludeEmployerIds = (data) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-employers`, {params: data})

export const requestDeleteExcludeEmployerIds = (data) =>
    apiRequest.delete(`/dvtjcuv/run-dvtjcuv/search-cdd-job/exclude-employers`, {data: data});
